/* eslint-disable */
import React from 'react';
import { useDispatch } from 'react-redux';
import { userActions } from 'redux/actions';
import { extLocalStore } from 'util/localStorage';
import { cacheKey, PROVIDERS } from 'appConstants';

export const useAuthenticateUser = (user, auth0ClientInitiated) => {
	const dispatch = useDispatch();
	const token = extLocalStore.getItem(cacheKey.TOKEN);
	const cachedProviders = extLocalStore.getItem(PROVIDERS);
	const cachedAuth0Provider = (cachedProviders || []).find((auth) => auth.authType === 'AUTH0');
	const hasToken = Boolean(token || cachedAuth0Provider);
	const [isRefreshingToken, setIsRefreshingToken] = React.useState(hasToken);

	React.useEffect(
		() => {
			(async () => {
				if (!user.authenticated && (token || auth0ClientInitiated)) {
					const initiatedViaLoginView = extLocalStore.onLogin;
					/**
					 * Prevent fetchTokenInfo execution if user is attempting to log in, otherwise
					 * it will result in faild request and all pertient cached data will be erased.
					 *
					 * Do not combine below condition with above condition to keep logic clear.
					 */
					if (!initiatedViaLoginView) {
						await dispatch(userActions.sessionInfo());
						setIsRefreshingToken(false);
					}
				}
			})();
		},
		[auth0ClientInitiated]
	);

	return { isRefreshingToken };
};
